import api from './api';

export type ReleaseComponent = 'cli' | 'ssh-agent' | 'relay-agent';

export interface DownloadsInfo {
  configured: boolean;
  components: Partial<Record<ReleaseComponent, string[]>>;
  link_ttl_seconds?: number;
}

export interface DownloadLink {
  url: string;
  file: string;
  expires_at: string;
}

/** Which release files this server can hand out, and whether it can at all. */
export const getDownloads = async (): Promise<DownloadsInfo> => {
  const response = await api.get<DownloadsInfo>('/downloads');
  return response.data;
};

/** A short-lived signed link to one release file (the bucket itself is private). */
export const getDownloadLink = async (component: ReleaseComponent, file: string): Promise<DownloadLink> => {
  const response = await api.get<DownloadLink>(`/downloads/${component}/${encodeURIComponent(file)}`);
  return response.data;
};
